export default {"src":"https://appsumo2next-cdn.appsumo.com/_next/static/media/hype.35cc5048.svg","height":32,"width":32};